<script lang="ts" setup></script>

<template>
  <RouterView />
</template>

<style scoped></style>
